import '@fortawesome/fontawesome-free/css/all.min.css';
export default function installFontAwesome() {
    // FontAwesome CSS is imported globally
    console.log('FontAwesome plugin installed');
}
